import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import statii from './modules/statii';
import zayavki from './modules/zayavki';
import filters from './modules/filters';
import bddsplan from './modules/bddsplan';
import bddsfact from './modules/bddsfact';
import bddsplanfact from './modules/bddsplanfact';
import planpostuplen from './modules/planpostuplen';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        auth: auth,
        statii: statii,
        zayavki: zayavki,
        filters: filters,
        bddsplan: bddsplan,
        bddsfact: bddsfact,
        bddsplanfact: bddsplanfact,
        planpostuplen: planpostuplen
    }
});